module.exports = require('./src');



/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/index.js
 ** module id = 53
 ** module chunks = 0
 **/